import React from 'react'
import { Link } from 'react-router-dom'
import img from "../assets/logo/kalpana-logo.png"

const FooterOne = () => {
    const colors = {
        blue: '#083d74',
        orange: '#F58220',
        text: '#4B2C20'
    };

    return (
        <footer className="footer" style={{ backgroundColor: "#ffffff", marginBottom: '20px', marginTop: "25px" }}>
            <div className="container container-lg">
                <div className="footer-item-wrapper">

                    {/* 1. Logo & About */}
                    <div className="footer-item footer-logo-col">
                        <div className="footer-item__logo mb-24">
                            <Link to="/">
                                <img src={img} alt="logo" style={{ maxWidth: "160px" }} />
                            </Link>
                        </div>
                        <p style={{ color: colors.text, fontSize: "14px", lineHeight: "1.6" }}>
                            Organic & homemade foods from <br />Tirunelveli & Andhra
                        </p>
                    </div>

                    {/* 2. Quick Links */}
                    <div className="footer-item footer-links-col">
                        <h6 className="footer-col-title" style={{ color: colors.blue }}>QUICK LINKS</h6>
                        <ul className="footer-menu list-unstyled p-0">
                            {['Home', 'About', 'Shop', 'Contact us'].map((link) => (
                                <li className="mb-16" key={link}>
                                    <Link
                                        to={
                                            link === 'Home' ? '/' :
                                            link === 'Contact us' ? '/contact' :
                                            `/${link.toLowerCase()}`
                                        }
                                        className="footer-link"
                                        style={{ textDecoration: 'none', color: "#666", fontSize: "14px", transition: "0.3s" }}>
                                        {link}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                {/* 3. Customer Support */}
<div className="footer-item footer-support-col">
    <h6
        className="footer-col-title"
        style={{ color: colors.blue }}
    >
        CUSTOMER SUPPORT
    </h6>

    <ul className="footer-menu list-unstyled p-0">
        {[
            {
                name: 'Shipping Policy',
                path: '/shipping-policy'
            },
            {
                name: 'Return Policy',
                path: '/return-policy'
            },
            {
                name: 'Privacy Policy',
                path: '/privacy-policy'
            },
            {
                name: 'Terms & Conditions',
                path: '/terms-conditions'
            }
        ].map((item) => (
            <li className="mb-16" key={item.name}>
                <Link
                    to={item.path}
                    className="footer-link"
                    style={{
                        textDecoration: 'none',
                        color: "#666",
                        fontSize: "14px",
                        transition: "0.3s"
                    }}
                >
                    {item.name}
                </Link>
            </li>
        ))}
    </ul>
</div>

                    {/* 4. Address */}
                    <div className="footer-item footer-address-col">
                        <h6 className="footer-col-title" style={{ color: colors.blue }}>
                            ADDRESS
                        </h6>
                        <p style={{ color: colors.text, fontSize: "14px", lineHeight: "1.8", margin: 0 }}>
                            Plot No B4, C1, Karpagam Illam,<br />
                            Sree Srinivasan Nagar Extension,<br />
                            Thandalam Road,<br />
                            Kovur,<br />
                            Kancheepuram District,<br />
                            Chennai - 600128,<br />
                            Tamil Nadu
                        </p>
                    </div>

                    {/* 5. Social Media */}
                    <div className="footer-item footer-social-col">
                        <h6 className="footer-col-title" style={{ color: colors.blue }}>SOCIAL MEDIA</h6>
                        <ul className="footer-social-list list-unstyled p-0">
                            {[
                                { icon: 'ph-facebook-logo',  url: 'https://www.facebook.com' },
                                { icon: 'ph-twitter-logo',   url: 'https://www.twitter.com' },
                                { icon: 'ph-instagram-logo', url: 'https://www.instagram.com' },
                                { icon: 'ph-linkedin-logo',  url: 'https://www.linkedin.com' }
                            ].map((social, idx) => (
                                <li key={idx}>
                                    <a href={social.url} target="_blank" rel="noopener noreferrer"
                                        className="social-icon-box"
                                        style={{
                                            width: "40px", height: "40px",
                                            display: "flex", alignItems: "center", justifyContent: "center",
                                            backgroundColor: "#f0f4f8", color: colors.blue,
                                            borderRadius: "50%", transition: "0.3s", fontSize: "20px"
                                        }}>
                                        <i className={`ph-fill ${social.icon}`} />
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                </div>
            </div>

            <style>{`
                /* ── Base Layout ── */
                .footer-item-wrapper {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    align-items: flex-start;
                    gap: 24px;
                }

                /* ALL columns: same flex-basis (0) so they grow equally */
                .footer-item,
                .footer-logo-col,
                .footer-links-col,
                .footer-support-col,
                .footer-address-col,
                .footer-social-col {
                    flex: 1 1 0;
                    min-width: 130px;
                    max-width: 220px;
                }

                .footer-col-title {
                    font-size: 16px;
                    font-weight: 700;
                    letter-spacing: 0.5px;
                    margin-bottom: 20px;
                    margin-top: 0;
                }

                .footer-social-list {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    gap: 12px;
                    margin-top: 20px;
                }

                /* ── Hover ── */
                .footer-link:hover { color: ${colors.orange} !important; padding-left: 5px; }
                .social-icon-box:hover {
                    background-color: ${colors.blue} !important;
                    color: white !important;
                    transform: translateY(-3px);
                }

                /* ══ TABLET ≤ 768px ══ */
                @media (max-width: 768px) {
                    .footer-item-wrapper {
                        flex-direction: column !important;
                        align-items: center !important;
                        gap: 28px;
                    }
                    .footer-item,
                    .footer-logo-col,
                    .footer-links-col,
                    .footer-support-col,
                    .footer-address-col,
                    .footer-social-col {
                        flex: unset !important;
                        width: 100% !important;
                        max-width: 100% !important;
                        text-align: center !important;
                    }
                    .footer-logo-col img {
                        display: block;
                        margin: 0 auto 12px;
                    }
                    .footer-menu {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                    .footer-menu li { margin-bottom: 10px !important; }
                    .footer-col-title { text-align: center; }
                    .footer-social-list {
                        justify-content: center;
                        margin-top: 16px;
                    }
                    .footer-link:hover { padding-left: 0 !important; }
                }

                /* ══ MOBILE ≤ 576px ══ */
                @media (max-width: 576px) {
                    .footer-col-title { font-size: 13px !important; }
                    .footer-menu li a { font-size: 13px !important; }
                    .footer-logo-col p { font-size: 13px !important; }
                    .footer-item-wrapper { gap: 22px; }
                }

                /* ══ SMALL MOBILE ≤ 400px ══ */
                @media (max-width: 400px) {
                    .footer-menu li a { font-size: 12px !important; }
                    .footer-logo-col p  { font-size: 12px !important; }
                    .social-icon-box {
                        width: 34px !important;
                        height: 34px !important;
                        font-size: 16px !important;
                    }
                }
            `}</style>
        </footer>
    )
}

export default FooterOne;